import withLoading from '@oncolens/oncolens-ui/lib/components/Common/withLoading';
import { SectionTitle } from '@/components/Layout/SectionTitle';
import React from 'react';
import { RequestDto } from '@oncolens/oncolens-ui/lib/dto/event/request';

interface ReferringProviderInformationProps {
	eventData: RequestDto;
}

export const ReferringProviderInformation = ({ eventData }: ReferringProviderInformationProps) => {
  return (
    <div className="print:hidden">
      <SectionTitle title="Requesting Provider Contact Information" />
      <ReferringProviderInformationBodyWithLoading isLoading={!eventData} eventData={eventData} />
    </div>
  );
};

const ReferringProviderInformationBody = ({ eventData }: ReferringProviderInformationProps) => {
  return (
    <div className="flex mb-4">
      <dl className="flex-1 mx-3">
        <div>
          <dt className="inline mr-1 font-bold">Name: </dt>
          <dd className="inline" data-cy="requesting-provider-name">
            {eventData?.referringProviderName}
          </dd>
        </div>
        <div>
          <dt className="inline mr-1 font-bold">Email: </dt>
          <dd className="inline" data-cy="requesting-provider-email">
            {eventData?.referringProviderEmail}
          </dd>
        </div>
        <div>
          <dt className="inline mr-1 font-bold">Phone: </dt>
          <dd className="inline" data-cy="requesting-provider-phone">
            {eventData?.referringProviderPhone}
          </dd>
        </div>
      </dl>
    </div>
  );
};

const ReferringProviderInformationSkeleton = () => (
  <div className="flex mb-4">
    <dl className="flex-1 mx-3">
      <div className="py-0.5">
        <dt className="block h-5 bg-gray-300 rounded-lg w-28 animate-pulse"></dt>
      </div>
      <div className="py-0.5">
        <dt className="block h-5 bg-gray-300 rounded-lg w-36 animate-pulse"></dt>
      </div>
      <div className="py-0.5">
        <dt className="block h-5 bg-gray-300 rounded-lg w-28 animate-pulse"></dt>
      </div>
    </dl>
  </div>
);

const ReferringProviderInformationBodyWithLoading = withLoading(
  ReferringProviderInformationBody,
  ReferringProviderInformationSkeleton
);
